/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';

const state = {
  parkingSpots: {},
  error: null,
};

const getters = {
  parkingSpots: state => state.parkingSpots,
  error: state => state.error,
};

const actions = {
  fetch({ commit }) {
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/products/parking-spots-info`)
      .then((response) => {
        commit(mTypes.FETCH_PARKING_SPOTS, response.body);
      }).catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
};

const mutations = {
  [mTypes.FETCH_PARKING_SPOTS](state, data) {
    state.parkingSpots = data;
    state.error = null;
  },
  [mTypes.CLEAR_STATE](state) {
    state.parkingSpots = {};
    state.error = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/users/parkingSpots.js